import * as accessToken from '../utils/accessToken';

export const setAuth = (token, data) => {
  // Set jwt cookie.
  accessToken.set(token);

  return {
    type: 'USER_SET',
    payload: data,
  };
};

export const logout = () => {
  // Remove jwt cookie on logout.
  accessToken.remove();

  return {
    type: 'USER_LOGOUT',
  };
};

export const login = ({ VisitId, otp }) => (dispatch) => {
};
